import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage, languageNames, SUPPORTED_LANGUAGES } from "./LanguageProvider";
import { Check, Languages } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

/** Ghost by default — an icon, no outline (Andrew, 2026-09-28). */
export function LanguageToggle({ variant = "ghost" }: { variant?: "ghost" | "outline" } = {}) {
  const { language, setLanguage } = useLanguage();
  const t = useTranslation();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size="icon" data-testid="button-language-toggle">
          <Languages />
          <span className="sr-only">{t("shellThemeToggleLanguage", "Toggle Language")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LANGUAGES.map((code) => (
          <DropdownMenuItem 
            key={code}
            onClick={() => setLanguage(code)}
            data-testid={`button-language-${code}`}
            className={language === code ? "font-semibold" : ""}
          >
            <span className="flex items-center justify-between w-full">
              <span>{languageNames[code]}</span>
              {language === code && (
                <Check className="h-4 w-4 ml-2" />
              )}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}